import { render, staticRenderFns } from "./Drzave.vue?vue&type=template&id=4f0c4049&scoped=true&"
import script from "./Drzave.vue?vue&type=script&lang=js&"
export * from "./Drzave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c4049",
  null
  
)

export default component.exports